module.exports = __webpack_public_path__ + "img/head_4.a4a05451.png";